import React from "react";
import Home from "./components/Home";
import Main from "./components/Main";
import ScrollButtons from "./components/ScrollButtons";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Link,
  Navigate,
} from "react-router-dom";
import { Container, Navbar, Nav } from "react-bootstrap";
import AboutMe from "./components/AboutMe";
import { useEffect } from "react";

function App() {
  useEffect(() => {
    // Disable right-click (desktop)
    document.addEventListener("contextmenu", (e) => e.preventDefault());

    // Disable long-press image download (mobile)
    const disableLongPress = (e) => {
      if (e.target.tagName === "IMG") {
        e.preventDefault();
      }
    };

    document.addEventListener("touchstart", disableLongPress, {
      passive: false,
    });
    document.addEventListener("touchend", disableLongPress, { passive: false });

    // Cleanup
    return () => {
      document.removeEventListener("contextmenu", (e) => e.preventDefault());
      document.removeEventListener("touchstart", disableLongPress);
      document.removeEventListener("touchend", disableLongPress);
    };
  }, []);
  return (
    <>
      <Router>
        <Container fluid className="m-0 p-0">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/main" element={<Main />} />
            <Route path="/home" element={<Home />} />
            <Route path="*" element={<Navigate to="/main" replace />} />
          </Routes>
          <ScrollButtons />
        </Container>
      </Router>
    </>
  );
}

export default App;
